
import { Component, Watch } from 'vue-property-decorator';
import { EVENTS } from '../../../bus/events.const';
import { VueCssClasses } from '../../../utils/types';
import EmpathizePanel from './empathize-panel.vue';

@Component
export default class FullScreenEmpathizePanel extends EmpathizePanel {

  @Watch('showEmpathize', { immediate: true })
  onShowEmpathizeChanged(show: boolean) {
    this.$x.emit(EVENTS.ScrollEnabled, !show);
  }

  protected get cssClasses(): VueCssClasses {
    return [
      'ebx-empathize-panel--full-screen',
      { 'ebx-empathize-panel--open': this.showEmpathize }
    ];
  }

  getPositionStyle(searchBoxElement: HTMLElement): Partial<CSSStyleDeclaration> {
    const { height, top } = searchBoxElement.getBoundingClientRect();
    return {
      top: height + top + 'px'
    };
  }

  onScroll() {}
}
